//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import UserPublicAvatar from '@/components/users/UserPublicAvatar.vue'
import {
  authorContributionTotal,
  authorProfilePath,
  expertDisplayName,
  formatAuthorContribution,
} from '@/utils/userPublic.js'

const DESKTOP_LIMIT = 8
const TABLET_LIMIT = 6
const MOBILE_LIMIT = 4
const TABLET_MEDIA = 1024
const MOBILE_MEDIA = 640

export default {
  name: 'MainExperts',
  components: { UserPublicAvatar },
  props: {
    experts: {
      type: Array,
      default: () => [],
    },
    categoryMode: {
      type: Boolean,
      default: false,
    },
    visibleLimit: {
      type: Number,
      default: 4,
    },
    hasMore: {
      type: Boolean,
      default: false,
    },
    loadingMore: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      desktopColumns: 4,
      tabletColumns: 3,
      isMobile: false,
      isTablet: false,
    }
  },
  computed: {
    maxCardsCount() {
      if (this.categoryMode) return this.visibleLimit
      if (this.isMobile) return MOBILE_LIMIT
      if (this.isTablet) return TABLET_LIMIT
      return DESKTOP_LIMIT
    },
    hasMoreExperts() {
      if (this.categoryMode) return this.hasMore
      return this.experts.length > this.maxCardsCount
    },
    showAllExpertsCard() {
      return !this.categoryMode && this.hasMoreExperts
    },
    showMoreCard() {
      return this.categoryMode && this.hasMoreExperts
    },
    visibleExperts() {
      if (this.categoryMode) {
        const maxExpertsCount = this.hasMoreExperts ? this.visibleLimit - 1 : this.visibleLimit
        return this.experts.slice(0, maxExpertsCount)
      }

      const maxExpertsCount = this.hasMoreExperts ? this.maxCardsCount - 1 : this.maxCardsCount
      return this.experts.slice(0, maxExpertsCount)
    },
  },
  mounted() {
    this.updateViewport()
    window.addEventListener('resize', this.updateViewport, { passive: true })
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.updateViewport)
  },
  methods: {
    updateViewport() {
      const width = window.innerWidth
      this.isMobile = width < MOBILE_MEDIA
      this.isTablet = width >= MOBILE_MEDIA && width < TABLET_MEDIA
    },
    expertLink(expert) {
      return authorProfilePath(expert)
    },
    expertName(expert) {
      return expertDisplayName(expert)
    },
    expertContribution(expert) {
      return formatAuthorContribution(authorContributionTotal(expert))
    },
  },
}
